// extracted by mini-css-extract-plugin
export default {"container":"Tp-z","ratingLayout":"Up-z","ratingLabel":"Vp-z","nonInteractiveRatingLabel":"Wp-z"};